import { call, put, takeLatest } from "redux-saga/effects";
import { LOGIN, REGISTER, WHOAMI } from "../Constants";
import store from "../store"
import api from "../utils/apiRoutes"
import { loginError, loginRet, registerError, registerRet, whoamiError, whomaiRet } from '../actions/authActions'
import Cookies from "js-cookie";

function* loginSaga() {
    const  data = yield store.getState().authStore.login

    try {          
        const apiData = yield call(api.auth.login, data)
        if(apiData.success) {
            Cookies.set("token_medical_auth", apiData.token)
            yield put(loginRet({
                success: true,
                message: apiData.message || "Login Successful",
                token: apiData.token,
                user: {
                    name: apiData.data.name,
                    email: apiData.data.email,
                    mobileNumber: apiData.data.mobileNumber,
                    userId: apiData.data._id,
                    profileImage: apiData.data.imageUrl
                }
            }))
        }
        else {
            yield put(loginRet({
                success: false,
                message: apiData.message ? apiData.message : "Invalid Credentials"
            }))
            // yield put(loginError())
        }

    } catch (error) {
        yield put(loginRet({
            success: false,
            message: "Invalid Credentials"
        }))
        // yield put(loginError())
    }
}

function* whoamiSage() {
    const headers  = { 'headers': { 'Authorization':`Bearer ${Cookies.get("token_medical_auth")}` } }

    try {          
        const apiData = yield call(api.auth.whoami, headers)
        // console.log({apiData})
        if(apiData.success)
            yield put(whomaiRet({
                success: true,
                message: apiData.message || "Login Successful",
                token: apiData.token,
                user: {
                    name: apiData.data.name,
                    email: apiData.data.email,
                    address: apiData.data.address,
                    basicDetailUpdates: apiData.data.basicDetailUpdates,
                    registrationNumber: apiData.data.registrationNumber,
                    mobileNumber: apiData.data.mobileNumber,
                    userId: apiData.data._id,
                    profileImage: apiData.data.imageUrl,
                    bankDetails: apiData.data.bankDetails,
                    phoneNumber: apiData.data.phoneNumber,
                    careType: apiData.data.careType,
                    city: apiData.data.city,
                    state: apiData.data.state,
                    pinCode: apiData.data.pinCode,
                    rohiniID: apiData.data.rohiniID,
                    panNumber: apiData.data.accountDetails?.panNumber,
                    panCard: apiData.data.accountDetails?.panURL,
                    profileDocuments: apiData.data.profileDocuments,
                    ppnStatus: apiData.data.ppnStatus,
                    registrationAuthority: apiData.data.registrationAuthority,
                    alternateNumber: apiData.data.alternateNumber,
                    hospitalType: apiData.data.multispeciality,
                    medicalSuperintendent: apiData.data.medicalSuperintendent,
                    tpaHead: apiData.data.marketingTpaHead,
                    bedsDetails: apiData.data.bedsDetails,
                    platformFee: apiData.data.platformSubscriptionFee,
                    representativeName: apiData.data.representativeName,
                    representativeDesignation: apiData.data.representativeDesignation,
                    termsChecked: apiData.data.termsChecked,
                }
            }))
        else {
            yield put(whomaiRet({
                success: false,
                message: "Token invalid",
                user: null
            }))
            Cookies.remove('token_medical_auth')
            window.location.reload()
        }

    } catch (error) {
        yield put(whomaiRet({
            success: false,
            message: "Error occured",
            user: null
        }))
        Cookies.remove('token_medical_auth')
        window.location.reload()
    }
}

function* registerSaga() {
    const  data = yield store.getState().authStore.register

    try {          
        const apiData = yield call(api.auth.register, data)
        if(apiData.success)
            yield put(registerRet({
                success: true,
                message: apiData.message || "Registration Successful",
                token: apiData.token,
                user: {
                    name: apiData.user.name,
                    email: apiData.user.email,
                    mobileNumber: apiData.user.mobileNumber,
                    userId: apiData.user._id,
                    profileImage: apiData.user.imageUrl
                }
            }))
        else {
            yield put(registerRet({
                success: false,
                message: "User already registered",
            }))
            // yield put(registerError())
        }

    } catch (error) {
        yield put(registerRet({
            success: false,
            message: "Registration Unsuccessful",
        }))
        // yield put(registerError())
    }
}

export const authSaga = [
    takeLatest(LOGIN, loginSaga),
    takeLatest(WHOAMI, whoamiSage),
    takeLatest(REGISTER, registerSaga)
]

export default authSaga